import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBarLevel1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.33333 15H2.66667C2.29848 15 2 15.2149 2 15.48V20.52C2 20.7851 2.29848 21 2.66667 21H5.33333C5.70152 21 6 20.7851 6 20.52V15.48C6 15.2149 5.70152 15 5.33333 15Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.66699 11.5H10.333C10.4115 11.5 10.4662 11.5261 10.4922 11.5469C10.4955 11.5495 10.498 11.5518 10.5 11.5537V20.4453C10.498 20.4473 10.4958 20.4502 10.4922 20.4531C10.4662 20.4739 10.4115 20.5 10.333 20.5H7.66699C7.58848 20.5 7.53378 20.4739 7.50781 20.4531C7.50421 20.4502 7.50202 20.4473 7.5 20.4453V11.5537C7.50197 11.5518 7.50449 11.5495 7.50781 11.5469C7.52729 11.5313 7.5626 11.5122 7.6123 11.5039L7.66699 11.5Z",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.667 7.5H15.333C15.4052 7.5 15.4571 7.52479 15.4834 7.54688C15.4931 7.55504 15.4979 7.56103 15.5 7.56445V20.4346C15.4981 20.4378 15.4938 20.4443 15.4834 20.4531C15.4571 20.4752 15.4052 20.5 15.333 20.5H12.667C12.5948 20.5 12.5429 20.4752 12.5166 20.4531C12.5062 20.4443 12.5019 20.4378 12.5 20.4346V7.56445C12.5021 7.56103 12.5069 7.55504 12.5166 7.54688C12.5363 7.53034 12.5702 7.51193 12.6162 7.50391L12.667 7.5Z",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.667 3.5H20.333C20.4011 3.5 20.4508 3.52392 20.4775 3.54688C20.49 3.55765 20.4958 3.56686 20.498 3.57129C20.4991 3.57337 20.4999 3.57492 20.5 3.5752V20.4248C20.4999 20.4251 20.4991 20.4266 20.498 20.4287C20.4958 20.4331 20.49 20.4424 20.4775 20.4531C20.4508 20.4761 20.4011 20.5 20.333 20.5H17.667C17.5989 20.5 17.5492 20.4761 17.5225 20.4531C17.51 20.4424 17.5042 20.4331 17.502 20.4287C17.5009 20.4266 17.5001 20.4251 17.5 20.4248V3.5752C17.5001 3.57492 17.5009 3.57337 17.502 3.57129C17.5042 3.56686 17.51 3.55765 17.5225 3.54688C17.5425 3.52965 17.5753 3.51169 17.6191 3.50391L17.667 3.5Z",
			stroke: "currentColor"
		})
	]
});
export default SvgBarLevel1;
